export const isChromeOnIos = () => {
	const ua = window.navigator.userAgent
	return /CriOS/i.test(ua) // Detect Chrome on iOS
}

export const isIos = () => {
	const ua = window.navigator.userAgent
	return /iPhone|iPad|iPod/i.test(ua)
}

export const isMacSafari = () => {
	const ua = window.navigator.userAgent
	return /Safari/i.test(ua) && /Macintosh/i.test(ua) && !/Chrome/i.test(ua)
}

export const isMacChrome = () => {
	const ua = window.navigator.userAgent
	return /Chrome/i.test(ua) && /Macintosh/i.test(ua) && !/Edg/i.test(ua)
}

export const isInStandaloneMode = () => window.navigator.standalone === true
